import {
  Host,
  Input,
  OnInit,
  Optional,
  SkipSelf,
  ViewChild,
  Component,
  forwardRef,
  ViewEncapsulation,
} from '@angular/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';

import { ComponentTypesEnum } from '../../enums';
import { SelectControlValueType } from '../../types';
import {BaseControlComponent, Helper, SelectControl} from '../../classes';

import { SelectOptionInterface } from './interfaces';

type SelectValueType = number | string | boolean | number[] | string[];

@Component({
  selector: 'app-select',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectComponent),
    multi: true,
  }],
  encapsulation: ViewEncapsulation.None,
})
export class SelectComponent
  extends BaseControlComponent<SelectControlValueType, MatSelectChange, SelectControl>
  implements OnInit {

  @Input() public outlined: boolean;

  @ViewChild('select', { static: true }) public selectReference: MatSelect;

  constructor(
    @Optional() @Host() @SkipSelf()
    protected controlContainer: ControlContainer,
  ) {
    super(controlContainer);

    this.outlined = false;
    this.selectReference = {} as MatSelect;
  }

  ngOnInit() {
    this.asFormsControl();
    this.checkInvalid();
  }

  changeValue(event: MatSelectChange): void {
    if (this.onChange) {
      this.onChange(event.value);
    }

    this.checkInvalid();
    this.control?.resetErrors();

    super.writeValue(event.value);
  }

  writeValue(value: SelectValueType): void {
    if (!Array.isArray(value)) {
      const filteredOptions = this.asFormsControl().options.filter((option: SelectOptionInterface) => {
        return value === option.value;
      });

      if (filteredOptions.length !== 0) {
        this.selectReference.value = filteredOptions[0].value;
        super.writeValue(filteredOptions[0].value);
      } else {
        switch (typeof value) {
          case 'string':
            this.selectReference.value = '';
            super.writeValue('');
            break;
          case 'boolean':
            this.selectReference.value = !value ? null : value;
            super.writeValue(!value ? null : value);
            break;
          default:
            this.selectReference.value = null;
            super.writeValue(null);
        }
      }
    } else {
      if (value.length > 0) {
        this.selectReference.value = value;
        super.writeValue(value);
      } else {
        this.selectReference.value = [];
        super.writeValue([]);
      }
    }

    this.checkInvalid();
    this.control?.resetErrors();
  }

  asFormsControl(): SelectControl {
    if (!this.control || !(this.control instanceof SelectControl)) {
      this.control = new SelectControl({
        name: '',
        value: '',
        placeholder: '',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        invalid: false,
        errors: [],
        options: [],
        multiple: false,
      });
    }

    if ((typeof this.controlPlaceHolder !== 'undefined') && this.control) {
      this.control.placeholder = this.controlPlaceHolder;
    }

    return (this.control as SelectControl);
  }
}
